// @ts-nocheck
import { get, post, put, deleteRequest } from './utils/api/base';
const API_URL = process.env.REACT_APP_BASE_API_URL || 'http://localhost:3500';
/**
 * @typedef {Object} Operacao
 * @property {number} Id - ID Ãºnico da operaÃ§Ã£o
 * @property {string} NomeOperacao - Nome da operaÃ§Ã£o
 * @property {string} Situacao - SituaÃ§Ã£o da operaÃ§Ã£o (Ativo, Inativo)
 * @property {number} DiasRecorrencia - Dias de recorrÃªncia
 * @property {boolean} RecorrenciaLigada - Se a recorrÃªncia estÃ¡ ativa
 * @property {number} ValorIndividualPallet - Valor individual do pallet
 * @property {number} ValorEtiquetas - Valor das etiquetas
 * @property {number} ValorArmazenagem - Valor da armazenagem
 * @property {number} Freetime - Tempo livre
 * @property {string} Observacao - ObservaÃ§Ãµes
 * @property {string} TipoDaOperacao - Tipo da operaÃ§Ã£o
 * @property {boolean} GerarCobranca - Se gera cobranÃ§a
 * @property {string} DataCriacao - Data de criaÃ§Ã£o
 * @property {string} DataModificacao - Data de modificaÃ§Ã£o
 * @property {number} UsuarioCriacao - ID do usuÃ¡rio que criou
 * @property {number} UsuarioModificacao - ID do usuÃ¡rio que modificou
 */
/**
 * @typedef {Object} OperacaoCreatePayload
 * @property {string} NomeOperacao - Nome da operaÃ§Ã£o
 * @property {string} [Situacao] - SituaÃ§Ã£o da operaÃ§Ã£o
 * @property {number} [DiasRecorrencia] - Dias de recorrÃªncia
 * @property {boolean} [RecorrenciaLigada] - Se a recorrÃªncia estÃ¡ ativa
 * @property {number} [ValorIndividualPallet] - Valor individual do pallet
 * @property {number} [ValorEtiquetas] - Valor das etiquetas
 * @property {number} [ValorArmazenagem] - Valor da armazenagem
 * @property {number} [Freetime] - Tempo livre
 * @property {string} [Observacao] - ObservaÃ§Ãµes
 * @property {string} [TipoDaOperacao] - Tipo da operaÃ§Ã£o
 * @property {boolean} [GerarCobranca] - Se gera cobranÃ§a
 */
/**
 * @typedef {Object} OperacaoFilters
 * @property {string} [NomeOperacao] - Filtro por nome da operaÃ§Ã£o
 * @property {string} [Situacao] - Filtro por situaÃ§Ã£o
 * @property {string} [TipoDaOperacao] - Filtro por tipo da operaÃ§Ã£o
 * @property {boolean} [GerarCobranca] - Filtro por geraÃ§Ã£o de cobranÃ§a
 * @property {boolean} [RecorrenciaLigada] - Filtro por recorrÃªncia ativa
 * @property {number} [ClienteId] - Filtro por ID do cliente
 * @property {number} [quantidadePorPagina] - Quantidade de registros por pÃ¡gina
 * @property {number} [pagina] - NÃºmero da pÃ¡gina
 */
/**
 * @typedef {Object} OperacoesResponse
 * @property {Operacao[]} registros - Lista de operaÃ§Ãµes
 * @property {number} totalRegistros - Total de registros encontrados
 * @property {number} paginaAtual - PÃ¡gina atual
 * @property {number} quantidadePorPagina - Quantidade de registros por pÃ¡gina
 */
/**
 * Lista operaÃ§Ãµes com filtros e paginaÃ§Ã£o
 * @param {OperacaoFilters} filters - Filtros para a busca
 * @returns {Promise<OperacoesResponse>} Resposta com lista de operaÃ§Ãµes
 */
export const getOperacoes = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    // Adicionar filtros apenas se tiverem valor
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${API_URL}/operacoes?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Busca uma operaÃ§Ã£o especÃ­fica por ID
 * @param {number} id - ID da operaÃ§Ã£o
 * @returns {Promise<Operacao>} Dados da operaÃ§Ã£o
 */
export const getOperacaoById = async (id) => {
    const response = await get(`${API_URL}/operacoes/${id}`);
    return response?.data || response;
};
/**
 * Busca uma operaÃ§Ã£o especÃ­fica por ID (alias para getOperacaoById)
 * @param {number} id - ID da operaÃ§Ã£o
 * @returns {Promise<Operacao>} Dados da operaÃ§Ã£o
 */
export const getOperacao = async (id) => {
    const response = await get(`${API_URL}/operacoes/${id}`);
    return response?.data || response;
};
/**
 * Cria uma nova operaÃ§Ã£o
 * @param {OperacaoCreatePayload} payload - Dados da operaÃ§Ã£o a ser criada
 * @returns {Promise<Operacao>} OperaÃ§Ã£o criada
 */
export const createOperacao = async (payload) => {
    const response = await post(`${API_URL}/operacoes`, payload);
    return response?.data || response;
};
/**
 * Atualiza uma operaÃ§Ã£o existente
 * @param {number} id - ID da operaÃ§Ã£o
 * @param {OperacaoCreatePayload} payload - Dados atualizados da operaÃ§Ã£o
 * @returns {Promise<Operacao>} OperaÃ§Ã£o atualizada
 */
export const updateOperacao = async (id, payload) => {
    const response = await put(`${API_URL}/operacoes/${id}`, payload);
    return response?.data || response;
};
/**
 * Exclui uma operaÃ§Ã£o
 * @param {number} id - ID da operaÃ§Ã£o a ser excluÃ­da
 * @returns {Promise<void>}
 */
export const deleteOperacao = async (id) => {
    await deleteRequest(`${API_URL}/operacoes/${id}`);
};
/**
 * Busca operaÃ§Ãµes por tipo
 * @param {string} tipo - Tipo da operaÃ§Ã£o
 * @returns {Promise<Operacao[]>} Lista de operaÃ§Ãµes do tipo
 */
export const getOperacoesByTipo = async (tipo) => {
    const response = await get(`${API_URL}/operacoes/tipo/${encodeURIComponent(tipo)}`);
    return response?.data || response || [];
};
/**
 * Busca operaÃ§Ãµes ativas
 * @returns {Promise<Operacao[]>} Lista de operaÃ§Ãµes ativas
 */
export const getOperacoesAtivas = async () => {
    const response = await get(`${API_URL}/operacoes/ativas`);
    return response?.data || response || [];
};
/**
 * Busca operaÃ§Ãµes que geram cobranÃ§a
 * @returns {Promise<Operacao[]>} Lista de operaÃ§Ãµes que geram cobranÃ§a
 */
export const getOperacoesComCobranca = async () => {
    const response = await get(`${API_URL}/operacoes/cobranca`);
    return response?.data || response || [];
};
/**
 * ObtÃ©m estatÃ­sticas de operaÃ§Ãµes
 * @returns {Promise<Object>} EstatÃ­sticas de operaÃ§Ãµes
 */
export const getEstatisticasOperacoes = async () => {
    const response = await get(`${API_URL}/operacoes/estatisticas`);
    return response?.data || response || {};
};
